type HistoryEntryLike = {
  task?: { id?: string | null } | null;
  status: string;
};

/**
 * Walk job history in order and attach the previous status per task
 * (or the unscoped `'NULL'` bucket when the entry has no task).
 * The first entry for a bucket is treated as coming from `'Created'`.
 */
export function withPreviousHistoryStatus<T extends HistoryEntryLike>(
  entries: T[] | undefined
): Array<T & { previousStatus: string }> {
  const history: Array<T & { previousStatus: string }> = [];
  const prev: Record<string, string> = {};

  (entries ?? []).forEach((entry) => {
    const previousStatus = prev[entry.task?.id ?? 'NULL'] ?? 'Created';
    prev[entry.task?.id ?? 'NULL'] = entry.status;
    history.push({
      ...entry,
      previousStatus,
    });
  });

  return history;
}
